import { getSpotlightParticipantList } from '../../../base/participants';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { setRemoteParticipants } from '../../../filmstrip/actions.any';
/**
 * The button component which starts/stops the transcription.
 */
export class AbstractSortParticipantsButton extends AbstractButton {
    /**
     * Helper function to be implemented by subclasses, which should be used
     * to handle the closed caption button being clicked / pressed.
     *
     * @protected
     * @returns {void}
     */
    _handleClickOpenLanguageSelector() {
        // To be implemented by subclass.
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @override
     * @protected
     * @returns {void}
     */
    _handleClick() {
        this.props.dispatch(setRemoteParticipants(this.props.participants));
    }
    /**
     * Indicates whether this button is disabled or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isDisabled() {
        return false;
    }
}
/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code AbstractSortParticipantsButton} component.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The properties explicitly passed to the component
 * instance.
 * @private
 * @returns {{
 *     _requestingSubtitles: boolean,
 *     _language: string,
 *     visible: boolean
 * }}
 */
export function _abstractMapStateToProps(state, ownProps) {
    const participants = getSpotlightParticipantList(state);
    return {
        customId: 'item-sort-participants',
        participants
    };
}
